export const INITIAL_WIDTH = 430;
export const INITIAL_HEIGHT = 932;
export const DPR = 2;
export const UI_DEPTH = 1000;
export const LAYOUT_DEPTH = -1000;
export const BOARD_DEPTH = 10;
export const NODE_DEPTH = 10;
export const POPUP_OVERLAY_DEPTH = UI_DEPTH + 100;
export const POPUP_DEPTH = POPUP_OVERLAY_DEPTH + 10;
export const MAX_WIDTH = 800;

export const DEFAULT_NODE_WIDTH = 64 * DPR;
export const DEFAULT_NODE_HEIGHT = 40 * DPR;
export const CHECKPOINT_NODE_WIDTH = 128 * DPR;
export const CHECKPOINT_NODE_HEIGHT = 128 * DPR;

// keys for local storage

export const LOCAL_STORAGE_KEYS = {
  GOAL_NOTIFICATIONS_SHOWN: 'goal_notifications', // {[uuid]: true}
};
